import { Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { SectionContentProps } from "./SectionNextActions.decl.ts";
import { List } from "./SectionNextActions.styled.ts";

import { useCall } from "@/hooks/useCall/useCall";

import { SectionHeader } from "../SectionHeader/SectionHeader";
import { SectionLayout } from "../SectionLayout/SectionLayout";

function SectionContent({ items }: SectionContentProps) {
  const { t } = useTranslation();

  // When the call was not processed
  if (!items) {
    return (
      <Typography
        variant="bodyRegularS"
        color="text-disabled"
        data-test="no-actions-generated"
      >
        {t("call_context.no_actions_generated")}
      </Typography>
    );
  }

  // When the call was processed and no actions
  if (!items.length) {
    return (
      <Typography variant="bodyRegularS" color="text-disabled">
        {t("call_context.no_actions")}
      </Typography>
    );
  }

  return (
    <List>
      {items.map((item) => (
        <Typography key={item.ID} variant="bodyMediumM" as="li">
          {item.content}
        </Typography>
      ))}
    </List>
  );
}

export function SectionNextActions() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <SectionLayout data-test="next-actions-section">
      <SectionHeader>{t("call_context.action_items")}</SectionHeader>
      <SectionContent items={call.nextActions} />
    </SectionLayout>
  );
}
